export default __webpack_public_path__ + "static/media/bilingual.294a461d.svg";